import { render } from "./freeAuthService.vue?vue&type=template&id=cf0fbc8e&scoped=true&ts=true"
import script from "./freeAuthService.vue?vue&type=script&lang=ts"
export * from "./freeAuthService.vue?vue&type=script&lang=ts"

import "./freeAuthService.vue?vue&type=style&index=0&id=cf0fbc8e&lang=less&scoped=true"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf0fbc8e"]])

export default __exports__